var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9993 24.0055H8.87535C5.44602 24.0002 2.66602 21.3242 2.66602 18.0228C2.66602 14.7228 5.44602 12.0468 8.87535 12.0468C9.39935 9.6975 11.2673 7.78017 13.7753 7.01617C16.282 6.2535 19.05 6.75884 21.034 8.3495C23.018 9.93617 23.9167 12.3588 23.394 14.7082H24.714C26.554 14.7082 28.1407 15.7895 28.8847 17.3562M25.3327 29.3335V21.3335M25.3327 21.3335L29.3327 25.3335M25.3327 21.3335L21.3327 25.3335",
    stroke: "#354052",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.583172073d37aa50cd75b0371b42710d.svg";
export { ForwardRef as ReactComponent };